import React from "react"
import Skeleton from "react-loading-skeleton"
import "react-loading-skeleton/dist/skeleton.css"

/**
 * The modal's own shape while the document is being fetched.
 *
 * Shows where the viewer, the tabs and the footer will be rather than a bar over an
 * empty frame, so nothing jumps once the real content arrives.
 */
const ModalSkeleton = () => (
    <div className="idm-skeleton" data-testid="idm-loading-skeleton">
        <div className="idm-skeleton-header">
            <Skeleton circle width={30} height={30} />
            <div className="idm-skeleton-header-text">
                <Skeleton width={170} height={13} />
                <Skeleton width={260} height={10} />
            </div>
        </div>
        <div className="idm-skeleton-body">
            <div className="idm-skeleton-viewer">
                <Skeleton height="100%" containerClassName="idm-skeleton-fill" />
            </div>
            <div className="idm-skeleton-panel">
                <div className="idm-skeleton-tabs">
                    <Skeleton width={56} height={14} />
                    <Skeleton width={78} height={14} />
                    <Skeleton width={56} height={14} />
                </div>
                <Skeleton count={7} height={15} className="idm-skeleton-row" />
            </div>
        </div>
        <div className="idm-skeleton-footer">
            <Skeleton width={150} height={30} />
            <Skeleton width={190} height={30} />
        </div>
    </div>
)

export default ModalSkeleton
